import React, { createContext, useContext, useState, useEffect } from 'react';

const OrderAvailabilityContext = createContext({
    ordersEnabled: true,
    orderMessage: '',
    loading: true,
});

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const OrderAvailabilityProvider = ({ children }) => {
    const [ordersEnabled, setOrdersEnabled] = useState(true);
    const [orderMessage, setOrderMessage] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const res = await fetch(`${API_URL}/settings/order-availability`);
                if (res.ok) {
                    const data = await res.json();
                    setOrdersEnabled(data.orders_enabled);
                    setOrderMessage(data.message || '');
                }
            } catch (e) {
                // Default to enabled on fetch failure
            } finally {
                setLoading(false);
            }
        };
        fetchStatus();
        const interval = setInterval(fetchStatus, 60000);
        return () => clearInterval(interval);
    }, []);

    return (
        <OrderAvailabilityContext.Provider value={{ ordersEnabled, orderMessage, loading }}>
            {children}
        </OrderAvailabilityContext.Provider>
    );
};

export const useOrderAvailability = () => useContext(OrderAvailabilityContext);
